import { reject, join, trim, isEmpty } from 'lodash/fp';

export default (data = {}, isTwoLines = false, showCounty = true) => {
  const {
    street_address: streetAddress,
    apartment,
    city,
    county,
    state,
    zipcode
  } = data;
  const addressLine = apartment
    ? `${streetAddress} #${apartment}`
    : streetAddress;

  const arrAddress = showCounty ? [city, county || '', state] : [city, state];
  const cityCountyState = join(', ', reject(isEmpty, arrAddress));

  if (isTwoLines)
    return {
      line1: trim(addressLine),
      line2: trim(`${cityCountyState} ${zipcode || ''}`)
    };

  return `${addressLine}, ${cityCountyState} ${zipcode || ''}`;
};
